import cx from "classnames";
import styles from "./RelatedRow.module.css";
import React, { useEffect, useRef, useState } from "react";
import LazyLoad from "react-lazy-load";
import TopTitleRow from "../../Elements/TopTitleRow/TopTitleRow";
import Link from "next/link";
import CardList from "../CardList/CardList";

import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";

const RelatedRow = ({ title, rowData, rowTitle, allItemsLink }) => {
  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const ref = useRef();
  const slideright = () => {
    ref.current.scrollBy({
      top: 0,
      left: +400,
      behavior: "smooth",
    });
  };
  const slideleft = () => {
    ref.current.scrollBy({
      top: 0,
      left: -400,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    try {
      let scrolledElement = document.getElementById(
        "relatedRowWrapper" + String(title)?.trim()
      );
      scrolledElement.addEventListener("scroll", (event) => {
        if (scrolledElement.scrollLeft === 0) {
          setIsStart(true);
        } else {
          setIsStart(false);
        }
        if (
          scrolledElement.offsetWidth -
            (scrolledElement.scrollLeft + scrolledElement.scrollWidth) >
          -1
        ) {
          setIsEnd(true);
        } else {
          setIsEnd(false);
        }
      });
    } catch (error) {}
  });

  return (
    <div className={cx(styles.rowsContainer)}>
      <TopTitleRow title={title} />
      <div
        className={cx(
          styles.contentStyles,
          "d-inline-flex",
          "align-items-start",
          "overflow-auto",
          "position-relative"
        )}
      >
        <div
          id={"relatedRowWrapper" + String(title)?.trim()}
          ref={ref}
          className="d-flex align-items-start overflow-auto py-3"
        >
          {rowData?.map((item, key) => (
            <div key={key}>
              <LazyLoad offset={200}>
                <div className={cx(styles.itemCotainerHelpreStyles)}>
                  <CardList
                    img={item?.img}
                    imgAlt={item?.title}
                    title={item?.title}
                    cat={item?.cat}
                    date={item?.date}
                    dark={true}
                    duration={item?.duration}
                    link={item.link}
                  />
                </div>
              </LazyLoad>
            </div>
          ))}
          <div
            className={cx(
              styles.allNewsBtn,
              "d-flex",
              "align-items-center",
              "justify-content-center"
            )}
          >
            <Link
              href={allItemsLink}
              className={cx(
                styles.showAllNewsBtn,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "text-white"
              )}
              id="newsReadMoreBtn1"
              aria-label="newsReadMoreBtn"
            >
              {/*<Link aria-label="all related " href={'/'}>*/}
              {"مشاهده همه" + " " + rowTitle}
              {/*</Link>*/}
              <WestIcon
                style={{
                  fontSize: "16px",
                }}
              />
            </Link>
          </div>
        </div>
        <div className={cx(styles.newsBottomController, "position-absolute")}>
          <div
            style={{ gap: "15px" }}
            className="d-flex align-items-center justify-content-start"
          >
            <button
              onClick={slideright}
              className={cx(
                styles.sliderControllerBtn,
                isStart && styles.sliderControllerBtnDiactive,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "p-0"
              )}
              id="newsScrollToRightBtn"
              aria-label="scroll to right"
            >
              <EastIcon
                style={{
                  fontSize: "18px",
                  color: "rgba(31, 58, 225, 1)",
                }}
              />
            </button>
            <button
              // style={{ transform: "rotate(180deg)" }}
              onClick={slideleft}
              className={cx(
                styles.sliderControllerBtn,
                isEnd && styles.sliderControllerBtnDiactive,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "p-0"
              )}
              id="newsScrollToLeftBtn"
              aria-label="scroll to left"
            >
              <WestIcon
                style={{
                  fontSize: "18px",
                  color: "rgba(31, 58, 225, 1)",
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedRow;
